import { faFacebookF, faInstagram, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";
import logo from "../Images/LaTripleFrontera_Vertical-Blanco.png";

const Footer = () => {
  return (
    <footer className="mt-auto bg-dark text-light pt-5 px-5">
      <div className="container">
        <div className="row g-5 mb-5">
          <div className="col-lg-4 d-flex order-md-0 order-1">
            <div className="text-center m-auto">
              <h3>Contacto</h3>
              {/* <a
                href="tel:+59892434004"
                className="d-block mb-2 text-decoration-none text-reset d-flex align-items-center justify-content-center"
              >
                <FontAwesomeIcon icon={faPhone} className="fs-4 me-2" /> <span>+(598) 92 434 004</span>
              </a> */}
              <a
                href="mailto:bellaunionturismo@gmail.com"
                className="d-block mb-2 text-decoration-none text-reset d-flex align-items-center justify-content-center"
              >
                <FontAwesomeIcon icon={faEnvelope} className="fs-4 me-2" />{" "}
                <span>bellaunionturismo@gmail.com</span>
              </a>
              <h3 className="mt-4">Redes Sociales</h3>
              {/* <a
                href="https://wa.me/59892434004"
                target="_blanc"
                className="mb-2 text-decoration-none text-reset"
              >
                <FontAwesomeIcon icon={faWhatsapp} className="fs-2 mx-2" />
              </a> */}
              <a
                href="https://www.instagram.com/bellaunionturismo/"
                target="_blanc"
                className="mb-2 text-decoration-none text-reset"
              >
                <FontAwesomeIcon icon={faInstagram} className="fs-2 mx-2" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61550305677358"
                target="_blanc"
                className="mb-2 text-decoration-none text-reset"
              >
                <FontAwesomeIcon icon={faFacebookF} className="fs-2 mx-2" />
              </a>
              <a
                href="https://www.tiktok.com/@bellaunionturismorelax"
                target="_blanc"
                className="mb-2 text-decoration-none text-reset"
              >
                <FontAwesomeIcon icon={faTiktok} className="fs-2 mx-2" />
              </a>
            </div>
          </div>
          <div className="col-lg-4 d-flex order-md-2 order-0">
            <div className="m-auto text-center">
              <img src={logo} alt="La Bella" className="w-50" />
            </div>
          </div>
          <div className="col-lg-4 order-2">
            <div className="text-center">
              <h3>Enlaces</h3>
              <Link className="text-reset text-decoration-none d-block" to={"/"}>
                Inicio
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/area-protegida"}>
                Área Protegida
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/alojamiento"}>
                Alojamientos
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/gastronomia"}>
                Gastronomía
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/actividades"}>
                Actividades
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/carnaval"}>
                Carnaval
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/galeria"}>
                Galería
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/emprendimientos"}>
                Emprendimientos
              </Link>
              <Link className="text-reset text-decoration-none d-block" to={"/contacto"}>
                Contacto
              </Link>
            </div>
          </div>
        </div>
      </div>
      <small className="d-block text-center">
        Desarrollado por{" "}
        <a href="https://estol.dev" target="_blank" rel="noopener noreferrer">
          <img
            src="https://estol.dev/static/media/logo-light.abba1fc2e07796d44b42.png"
            alt="Esteban Olivera"
            height="28"
          />
        </a>{" "}
        ©{new Date().getFullYear()}
      </small>
    </footer>
  );
};

export default Footer;
